export default {
  text: '#020303',
  primary: '#cbb190', // '#b2c7c8',
  secondary: '#cbb190',
  background: '#fdfdfd',
  backgroundSecondary: '#f3eeea',
  light: '#FFF',
  dark: '#020303'
}
